module.exports = __webpack_public_path__ + "static/media/33.94145ff9.jpg";